import { activityFetch as fetch } from '../../components/feedback/requestActivity'
import React, { useState, useEffect, useRef } from 'react';
import {reqGet} from '../../Service';
import {reqPost} from '../../Service';
import './style.css';
import './styleN.css';
import document from '../../resource/image/document.jpg';
import ProjectCard from '../../components/ProjectCard';
import ProjectForm from '../../screen/Project/ProjectSubmit';
import { useRecoilState } from 'recoil';
import { ProjectListAtom } from '../../atoms/projectListAtom';
import { ProjectEditAtom } from '../../atoms/projectListAtom';
import ImgInput from '../../components/ImgInput';
import { faL } from '@fortawesome/free-solid-svg-icons';

/**프로젝트 등록 */
function ProjectRegister({reloadProjects, proj_id, isModify, editProject, setShowRegister}) {

  const [projectName, setProjectName] = useState('');
    const [projectDescription, setProjectDescription] = useState('');
    const [url, setUrl] = useState('');
    const [github, setGithub] = useState('');
    const [remote, setRemote] = useState('');
    const [imageUrl, setImageUrl] = useState(null);
    const [manager, setManager] = useState('');
    const [hostName, setHostName] = useState('');
    const [portNumber, setPortNumber] = useState('');
    const [fileServer, setFileServer] = useState('');
    const [database, setDatabase] = useState('');
    const [colorValue, setColorValue] = useState('');
    const [subColorValue, setSubColorValue] = useState('');
    const [projectNeeds, setProjectNeeds] = useState('');
    const [modifyMode, setModifyMode] = useRecoilState(ProjectEditAtom);
    const [existingImageUrl, setExistingImageUrl] = useState('');
    const [file_id, setFile_id] = useState('');

    const formRef = useRef(); // form ref 생성
    const fileInput = useRef(); // 파일 인풋 참조

    
    useEffect(() => {
      if (isModify && editProject) {
        setProjectName(editProject.projectName);
        setProjectDescription(editProject.projectDescription);
        setUrl(editProject.url);
        setGithub(editProject.github);
        setRemote(editProject.remote);
        setImageUrl(editProject.imageUrl);
        setManager(editProject.manager);
        setHostName(editProject.hostName);
        setPortNumber(editProject.portNumber);
        setFileServer(editProject.fileServer);
        setDatabase(editProject.database);
        setColorValue(editProject.colorValue);
        setSubColorValue(editProject.subColorValue);
        setProjectNeeds(editProject.projectNeeds);
                
      } else {
        setProjectName('');
        setProjectDescription('');
        setUrl('');
        setGithub('');
        setRemote('');
        setImageUrl('');
        setManager('');
        setHostName('');
        setPortNumber('');
        setFileServer('');
        setDatabase('');
        setColorValue('');
        setSubColorValue('');   
                
      }
    }, [isModify, editProject]);
    

    /** 파일 선택시 호출되는 함수 */
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setImageUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  /**새 프로젝트 */
  const handleAddSubmit = (event) => {
    setModifyMode(false);
    event.preventDefault();
    const formData = new FormData(formRef.current);
    
    fetch('https://file.skynet.re.kr:3402/upload/Image', {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      body: formData,
    })
    .then(() => {
      alert('프로젝트 등록 완료');
      setShowRegister(false);
      reloadProjects();
    })
    .catch(error => alert(`Error : ${error}`));
  };

    /**수정 */
    const handleModifySubmit = (event) => {
      setModifyMode(true);

      event.preventDefault();
      const imageFile = fileInput.current.files[0];
      const formData = new FormData(formRef.current);
    
      const updateProject = (imageUrl) => {
        const projectData = {
          proj_id: proj_id, // 수정할 프로젝트의 ID
          file_id: file_id,
          proj_name: projectName,
          proj_intro: projectDescription,
          proj_url: url,
          proj_github: github,
          proj_remote: remote,
          image_url: imageUrl, // 새 이미지 URL 또는 기존 URL
          manager: manager,
          host_name: hostName,
          port_number: portNumber,
          file_server: fileServer,
          database_info: database,
          color_value: colorValue,
          sub_color: subColorValue,
          proj_needs: projectNeeds,
        };
    
      fetch('/api/UpdateProject', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(projectData),
      })
      .then(response => {
        if (!response.ok) throw new Error('프로젝트 정보 업데이트 실패');
        alert('프로젝트 수정 완료');
        setShowRegister(false);
        reloadProjects();
      })
      .catch(error => alert(`Error : ${error}`));
    };
  
    if (imageFile) {
      formData.append('image_url', imageFile);
      fetch('https://file.skynet.re.kr:3402/upload/Image', {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        body: formData,
      })
        .then(response => response.json())
        .then(data => updateProject(data.imageUrl))
        .catch(error => alert(`Error : ${error}`));
    } else {
      updateProject(editProject.imageUrl);
    }
  };
      
  useEffect(() => {
    console.log(`Modify Mode is now: ${modifyMode}`);
  }, [modifyMode]);
  



  return (
  <div className='project-register-container'>
    <h1 className='addProjectHead'>프로젝트 등록</h1>
    <form ref={formRef} id='projectForm' encType='multipart/form-data' acceptCharset='UTF-8'>

    <div className='inputScreen'>
    <div className="input-row">
    <div>{proj_id}<label htmlFor='ProjectName'>프로젝트명</label>
    <input id="ProjectName" name='photo_projectName' defaultValue={projectName} onChange={(e) => setProjectName(e.target.value)} />
    </div>
    
    <div><label htmlFor='URL'>URL</label>
     <input 
     type="text" id="URL" name='photo_url' defaultValue={url} onChange={(e) => setUrl(e.target.value)} />
    </div>
    </div>
  
    <div className="input-row">
    <div><label htmlFor='ProjectDecr'>프로젝트 설명</label>
    <input id="ProjectDecr" name='photo_info' defaultValue={projectDescription} onChange={(e) => setProjectDescription(e.target.value)}
    /></div>
    </div>

    <div className="input-row">
    <div><label htmlFor='databace'>데이터베이스 정보</label>
    <input type='text' id='database' name='photo_database' defaultValue={database}  onChange={(e) => setDatabase(e.target.value)} />
    </div>
    </div>


    <div className="input-row">
    <div><label htmlFor='ProjectGit'>GitHub</label>
    <input type="text" id="ProjectGit" name='photo_github' defaultValue={github} onChange={(e) => setGithub(e.target.value)} />
    </div>

    <div><label htmlFor='ProjectGit'>원격</label>
    <input type="text" id="ProjectGit" name='photo_remote' defaultValue={remote} onChange={(e) => setRemote(e.target.value)} />
    </div>
    </div>

    <div className="input-row">

    <div><label htmlFor='img'>담당자</label>
    <input type="text" id="manager" name='photo_manager' defaultValue={manager} onChange={(e) => setManager(e.target.value)} />
    </div>
    <div><label htmlFor='HostName'>호스트 이름</label>
    <input type="text" id="HostName" name='photo_host' defaultValue={hostName}   onChange={(e) => setHostName(e.target.value)} />
    </div>
    </div>

    <div className="input-row">
    <div><label htmlFor='PortNum'>포트번호</label>
    <input type='text' id='PortNum' name='photo_port' defaultValue={portNumber}  onChange={(e) => setPortNumber(e.target.value)} />
    </div>
    <div><label htmlFor='FileServer'>파일서버 주소</label>
    <input type='text' id='fileServer' name='photo_fileServer' defaultValue={fileServer}  onChange={(e) => setFileServer(e.target.value)} />
    </div>
    </div>

    <div className="input-row">
    <div><label htmlFor='mainColor'>메인컬러</label>
    <input type='text' id='mainColor' name='photo_mainColor' defaultValue={colorValue}  onChange={(e) => setColorValue(e.target.value)} />
    </div>

    <div><label htmlFor='subColor'>서브컬러</label>
    <input type='text' id='subColor' name='photo_subColor' defaultValue={subColorValue}  onChange={(e) => setSubColorValue(e.target.value)} />
    </div>
    </div>

    <div className="input-row">
    <div><label htmlFor='projectNeeds'>요구사항</label><br />
    <textarea type='text' id='projectNeeds' name='photo_needs' defaultValue={projectNeeds}  onChange={(e) => setProjectNeeds(e.target.value)} />
    </div></div>
    
</div>

    <div className="input-img">
    <div>
    {/* <ImgInput type='file' setImageUrl={setImageUrl} id="imageFile" ref={fileInput} onChange={handleFileChange} /> */}
    <input type="file" id="imageFile" name='img' multiple ref={fileInput} onChange={(e)=>handleFileChange(e)} />

    </div></div><br />

    {isModify ? 
    <button className='submitBtn' type="button" onClick={(e)=>handleModifySubmit(e)}>저장{JSON.stringify(isModify)}</button> :
     <button type="button" className='submitBtn' onClick={(e)=>handleAddSubmit(e)}>등록{isModify}</button>}
    </form>

    </div>
  );
  }


export default function ProjectPage() {
  const [showRegister, setShowRegister]=useState(false);
  const [projectlist, setProjectlist] = useRecoilState(ProjectListAtom);
  const [editProject, setEditProject] = useRecoilState(ProjectEditAtom);
  const [isModify, setIsModify] = useState(false);

  /**ProjectCard에서 수정상태를 받으면 isModify true 상태를 ProjectRegister로 전달  */
  const modifyProject = (project) => {
    setIsModify(true);
    setEditProject(project);
    setShowRegister(prevState => !prevState);
  };

  useEffect(()=>{ 
    showProjectList();  
  },[]);

  /**프로젝트리스트 받아오기 */
  const showProjectList=()=>{
    reqGet('/api/getProjectList',{},(result)=>{ 
      setProjectlist(result);
    });
  }

  /**프로젝트 등록 버튼 클릭시엔 빈 input상태로 */
  const projectregister = () => {
    setShowRegister(prevState => !prevState);
    setIsModify(false);
    setEditProject({});  

  }

  return (
    <div className='projectPage'>
      <div className='registerButton'>
        <button onClick={projectregister} className='addProjectBtn'>프로젝트 등록</button></div>
      {showRegister && 
      <ProjectRegister 
      proj_id={editProject.proj_id} 
      editProject={editProject}
      setShowRegister={setShowRegister}
      onModify={projectregister} 
      reloadProjects={showProjectList} 
      isModify={isModify}
      
      />}
      
      <section className="card-container">

      {projectlist.length > 0 && projectlist.map((project) => (
      <ProjectCard 
        key={project.proj_id}
        proj_id={project.proj_id}
        file_id={project.file_id}
        projectName={project.proj_name}
        projectDescription={project.proj_intro}
        url={project.proj_url}
        github={project.proj_github}
        remote={project.proj_remote}
        imageUrl={project.image_url ? 'https://file.skynet.re.kr:2550/admin_antsnest/Project/' +project.image_url : ''}
        manager={project.manager}
        hostName={project.host_name}
        portNumber={project.port_number} 
        fileServer= {project.file_server}
        database={project.database_info}
        colorValue={project.color_value}
        subColorValue={project.sub_color}
        projectNeeds={project.proj_needs}
        refresh={showProjectList}
        setEditProject={setEditProject}
        onModify={modifyProject}
      />
      ))}

      </section>

    </div>
  );
}